module.exports = __webpack_public_path__ + "img/portrait.dd1223dd.jpg";